import React, { Component } from "react"
import { CDN_PUB_URL } from "../../../../constants"
import { MathKatex2 } from "../../../../components/MathKatex"
import { IComputerBasedPracticeTestQuestion } from "../types/practicetest"
import "./QuestionExplanationSAT.css"

interface Props {
    question: IComputerBasedPracticeTestQuestion
}

interface State {

}

export default class QuestionExplanationSAT extends Component<Props, State> {
    // Per Jennifer, choices may have images as well
    prepareChoice = (choice: string) => {
        if (!choice) return ""
        if (choice.includes("$CDN")) {
            let url = choice.replace("$CDN", CDN_PUB_URL)
            return `<img src=${url} class="question-option" alt="option"/>`
        }
        return choice
    }

    isCorrectAnswer = (question) => {
        let isCorrect = false
        let { correctAnswer, fillInAnswer, acceptableAnswers, userSubmittedAnswer } = question

        if (acceptableAnswers) {
            let allPossibleAnswers = acceptableAnswers.split(",").map(v => v.trim())
            let foundAnswer = allPossibleAnswers.find(possibleAnswer => possibleAnswer === fillInAnswer)

            if (foundAnswer) isCorrect = true
        }
        else {
            if (correctAnswer === userSubmittedAnswer) isCorrect = true
        }

        return isCorrect
    }

    prepareAnswerChoices = (question: IComputerBasedPracticeTestQuestion) => {
        let { choiceA, choiceB, choiceC, choiceD, correctAnswer, userSubmittedAnswer } = question
        let isCorrectA = correctAnswer === "A"
        let isCorrectB = correctAnswer === "B"
        let isCorrectC = correctAnswer === "C"
        let isCorrectD = correctAnswer === "D"
        let selectedA = userSubmittedAnswer === "A"
        let selectedB = userSubmittedAnswer === "B"
        let selectedC = userSubmittedAnswer === "C"
        let selectedD = userSubmittedAnswer === "D"
        let answers = [
            { value: "A", label: this.prepareChoice(choiceA), correct: isCorrectA, selected:  selectedA },
            { value: "B", label: this.prepareChoice(choiceB), correct: isCorrectB, selected:  selectedB },
            { value: "C", label: this.prepareChoice(choiceC), correct: isCorrectC, selected:  selectedC },
            { value: "D", label: this.prepareChoice(choiceD), correct: isCorrectD, selected:  selectedD },
        ]

        return answers
    }

    determineClassName = (choice) => {
        let {correct, selected} = choice
        let className = "answer-choice"

        if (correct && selected) className += " answer-choice--correct-and-selected"
        else if (correct) className += " answer-choice--correct"
        else if (selected) className += " answer-choice--selected"

        return className
    }

    prepareFeedback = (question: IComputerBasedPracticeTestQuestion, userAnswerFound: boolean, isCorrect: boolean) => {
        let { choiceA, correctAnswer, fillInAnswer, userSubmittedAnswer, gridIn } = question
        let isOmitted = !userAnswerFound

        // User found the answer correctly :)
        if (isCorrect) {
            return "Well done. You chose the correct answer."
        }

        // Omitted: No answer provided by the user!
        if (isOmitted) {
            // Check if this is multiple-choice or fillIn kind of answer
            if (choiceA) {
                return `You omitted your answer. The correct answer is ${correctAnswer}.`
            }
            else {
                return `You omitted your answer. The correct answer is ${gridIn}.`
            }
        }

        // Incorrect answer (could be coming from userSubmittedAnswer or fillIn answer)
        if (choiceA) {
            return `Your answer is ${userSubmittedAnswer}. The correct answer is ${correctAnswer}.`
        }

        return `Your answer is ${fillInAnswer}. The correct answer is ${gridIn}.`
    }

    render() {
        let {question} = this.props

        if (!question) return null

        let { questionText, questionQualifier, questionImage, questionNumber,
              choiceA, choiceB, choiceC, choiceD, correctAnswer,
              fillInAnswer, acceptableAnswers, userSubmittedAnswer, bookmarked,
              fullExplanation, lessonName, topicName, gridIn } = question
        let userAnswerFound = (fillInAnswer || userSubmittedAnswer) ? true: false
        let isCorrect = this.isCorrectAnswer(question)
        let choices = this.prepareAnswerChoices(question)
        let feedbackMessage = this.prepareFeedback(question, userAnswerFound, isCorrect)

        questionImage = questionImage && questionImage.replace("$CDN", CDN_PUB_URL)

        return (
            <div className="question-explanation-sat">
                <div className="container-fluid px-0">
                    <div className="row">
                        <div className="col-md-6 mb-4 mb-md-0">
                            <div className="choices mb-4">
                                <h3>Question {questionNumber} ({lessonName})</h3>
                                {questionImage && <img src={questionImage} alt="question image" />}
                                <p>
                                    <MathKatex2 mixedContent={questionText}/>
                                </p>
                                <p>
                                    <MathKatex2 mixedContent={questionQualifier}/>
                                </p>

                                { choiceA ?
                                    <>
                                        { 
                                            choices.map(choice => {
                                                let {value, label, correct, selected} = choice
                                                let className = this.determineClassName(choice)
                                                return (
                                                    <div className="answer-choice-wrapper">
                                                        <div key={value} className={`${className}`}>
                                                            <span className="answer-choice--value" >{value}</span>&nbsp;<MathKatex2 mixedContent={label}/>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </>
                                    :
                                    <>
                                        {acceptableAnswers && `Acceptable answer: ${gridIn}`}
                                    </>
                                }
                            </div>
                            <p className={`answer-choice--message ${!userAnswerFound ? "answer-choice--msg-err" : "" }`}>
                                <b>{feedbackMessage}</b>
                            </p>
                        </div>
                        <div className="col-md-6">
                            <h3>Explanation</h3>
                            <div className="full-exaplanation-sat">
                                <MathKatex2 mixedContent={fullExplanation}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
